import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'splitContentPipe',
    standalone: false
})
export class SplitContentPipe implements PipeTransform {

	transform(values: string[], separator = '|'): string {
		if (!values && !Array.isArray(values)) {
			return;
		}
		return values.join(` ${separator} `);
	}

}
